import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "welcome" }
const _hoisted_2 = { class: "welcome__title" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = { class: "welcome__text" }
const _hoisted_5 = { class: "welcome__avatar" }

import Title from '@/components/ui/Title'
import Avatar from '@/components/ui/Avatar'
import Button from '@/components/ui/Button'
import EarnedCard from '@/components/EarnedCard'

// Store
import { useCommonStore } from '@/store'

export default /*#__PURE__*/_defineComponent({
  __name: 'Welcome',
  setup(__props) {

// Components
const commonStore = useCommonStore()

return (_ctx: any,_cache: any) => {
  const _component_draw_svg = _resolveComponent("draw-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(Title), {
        type: "h2",
        theme: "big"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('hi')) + ",", 1),
          _hoisted_3,
          _createTextVNode(" " + _toDisplayString(_unref(commonStore).user.name) + "! ", 1)
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('welcome')), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_unref(Avatar), {
        picture: _unref(commonStore).user?.avatar,
        theme: "big"
      }, null, 8, ["picture"]),
      _createVNode(_unref(Button), {
        type: "router-link",
        to: {name: 'Profile'},
        theme: "icon"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_draw_svg, {
            name: "settings",
            width: "30",
            height: "30"
          })
        ]),
        _: 1
      })
    ]),
    _createVNode(_unref(EarnedCard), { class: "welcome__card" })
  ]))
}
}

})